module.exports = __webpack_public_path__ + "static/media/logoWhite.79fb33d4.svg";